import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useWelcomeModal() {
    const [searchParams, setSearchParams] = useSearchParams();

    const isOpen = searchParams.get("welcome") === "true";

    const openModal = useCallback(() => {
        setSearchParams((params) => {
            params.set("welcome", "true");
            return params;
        });
    }, [setSearchParams]);

    const closeModal = useCallback(() => {
        setSearchParams((params) => {
            params.delete("welcome");
            return params;
        });
    }, [setSearchParams]);


    return {isOpen, openModal, closeModal}
}
